import { useTranslation } from "react-i18next";
import logoBottomline from "../assets/logosCompanies/bottomline.png";
import logoFNE from "../assets/logosCompanies/fne.png";
import logoIgocreate from "../assets/logosCompanies/igocreate.png";
import logoKamoov from "../assets/logosCompanies/kamoov.png";
import logoQiara from "../assets/logosCompanies/qiara.svg";

const AboutPage = () => {
  const { t } = useTranslation();

  const experiences = [
    {
      name: "Qiara",
      key: "qiara",
      logo: logoQiara,
      url: "https://www.qiara.co",
      title: t("presentationPage.experience.qiara.title"),
      period: t("presentationPage.experience.qiara.period"),
      contributions: t("presentationPage.experience.qiara.contributions", {
        returnObjects: true,
      }) as string[],
    },
    {
      name: "Igocreate",
      key: "igocreate",
      logo: logoIgocreate,
      url: "https://www.igocreate.com",
      title: t("presentationPage.experience.igocreate.title"),
      period: t("presentationPage.experience.igocreate.period"),
      contributions: t("presentationPage.experience.igocreate.contributions", {
        returnObjects: true,
      }) as string[],
    },
    {
      name: "Bottomline Technologies",
      key: "bottomline",
      logo: logoBottomline,
      url: "https://www.bottomline.com",
      title: t("presentationPage.experience.bottomline.title"),
      period: t("presentationPage.experience.bottomline.period"),
      contributions: t("presentationPage.experience.bottomline.contributions", {
        returnObjects: true,
      }) as string[],
    },
    {
      name: "Kamoov",
      key: "kamoov",
      logo: logoKamoov,
      url: "https://www.kamoov.com",
      title: t("presentationPage.experience.kamoov.title"),
      period: t("presentationPage.experience.kamoov.period"),
      contributions: t("presentationPage.experience.kamoov.contributions", {
        returnObjects: true,
      }) as string[],
    },
    {
      name: "FNE",
      key: "fne",
      logo: logoFNE,
      url: "https://www.fne.org",
      title: t("presentationPage.experience.fne.title"),
      period: t("presentationPage.experience.fne.period"),
      contributions: t("presentationPage.experience.fne.contributions", {
        returnObjects: true,
      }) as string[],
    },
  ];

  return (
    <div className="font-helveticaNeue">
      <div className="flex flex-col gap-4">
        <h1 className="font-bold text-2xl">About</h1>
        <div className="flex flex-col gap-1">
          <p className="">
            {t("presentationPage.presentation.shortPresentation1")}
          </p>
          <p className="text-justify">
            {t("presentationPage.presentation.shortPresentation2")}
          </p>
          <p className="my-4">
            <a
              href="/files/JoachimDorel_CV.pdf"
              target="_blank"
              className="text-blue-700 dark:text-blue-400 hover:text-white hover:bg-blue-700 dark:hover:bg-blue-600 cursor-pointer"
            >
              {t("presentationPage.presentation.cvDownload")} →
            </a>
          </p>
        </div>
      </div>

      <section className="pb-8">
        <h2 className="text-black-800 dark:text-white font-bold">
          {t("homePage.experience.title")}
        </h2>
        <div className="mt-4 space-y-6">
          {experiences.map((experience) => (
            <div key={experience.key} className="flex flex-col items-start">
              <div className="flex w-full justify-between">
                <h3 className="font-medium">{experience.name}</h3>
                <h3 className="font-medium">{experience.period}</h3>
              </div>
              <p className="text-gray-500 dark:text-gray-400">
                {experience.title}
              </p>
              <div>
                <ul className="mt-2 list-disc pl-5 space-y-1">
                  {experience.contributions.map((contribution, index) => (
                    <li key={index}>{contribution}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
